<template>
  <v-row no-gutters>
    <v-col cols="12" md="12" class="pt-2 pl-2 pr-2">
      <v-text-field
        :loading="loading"
        append-inner-icon="mdi-magnify"
        density="compact"
        label="Search"
        variant="outlined"
        hide-details
        v-model="txtSearch"
        @input="inputSearch()"
      ></v-text-field>
    </v-col>
    <v-col
      cols="12"
      md="12"
      class="mt-2 pl-2 pr-2"
      v-for="(item, index) in friendList"
      :key="index"
      :style="{
        backgroundColor:
          item.userAccountId == selectedOne.userAccountId
            ? '#def3ff'
            : 'transparent',
      }"
      @click="selectedOne = item"
    >
      <v-menu v-model="menu">
        <template v-slot:activator="{ props }">
          <span v-bind="props">
            <v-row
              no-gutters
              class="pl-2 pt-1 pb-1 pr-2"
              @click.left.prevent="clickFriend(item, 1)"
              @click.right.prevent="menuDialog(item)"
            >
              <v-col cols="2" md="2">
                <span>
                  <div
                    class="container"
                    width="30vh"
                    height="30vh"
                    v-if="item.active"
                  >
                    <v-avatar
                      variant="outlined"
                      :image="srcMethod(item.profilePhoto)"
                      size="50"
                    >
                    </v-avatar>
                    <div class="bottom-right">
                      <span class="dot"></span>
                    </div>
                  </div>
                  <v-avatar
                    v-else
                    variant="outlined"
                    :image="srcMethod(item.profilePhoto)"
                    size="50"
                  ></v-avatar>
                </span>
              </v-col>
              <v-col cols="10" md="10">
                <v-row no-gutters>
                  <v-col cols="9" md="8">
                    <span
                      ><h4>{{ item.profileName }}</h4></span
                    >
                  </v-col>
                  <v-col cols="3" md="4">
                    <span class="text-right"
                      ><h6>{{ item.messageDate }}</h6></span
                    >
                  </v-col>
                  <v-col cols="10" md="10">
                    <div
                      class="cut-text text-caption"
                      v-if="item.sendMessage != ''"
                    >
                      {{ item.sendMessage }}
                    </div>
                    <div class="text-caption" v-else>Photo message</div>
                  </v-col>
                  <v-col cols="2" md="2" v-if="item.look != 0">
                    <center>
                      <v-btn variant="tonal" size="x-small" flat icon
                        ><h4>{{ item.look }}</h4></v-btn
                      >
                    </center>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </span>
        </template>
        <v-list
          density="compact"
          v-if="menu && menuSelected.userAccountId == item.userAccountId"
        >
          <v-list-item
            v-for="(menuObj, i) in rightMenuList"
            :key="i"
            @click="clickPageUnLike(item)"
          >
            <v-list-item-title density="compact">{{
              menuObj.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <v-col cols="12" md="12" >
      <v-dialog v-model="nameChangeDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 white--text bg-red">
            Name Change 
          </v-card-title>
          <v-card-subtitle>
            <v-text-field class="mt-3" label="Name Change" v-model="nameChange.profileName" variant="outlined"
              density="compact"/>
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="nameChangeDialog = false">
              CANCEL
            </v-btn>
            <v-btn  class="bg-red"  @click="clickNameChange()">
              Change
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
  <script>
import friService from "../service/FriendService";
import axios from "../config";
export default {
  data: () => ({
    selectedOne: {},
    friendList: [],
    tempFriendList: [],
    menu: false,
    rightMenuList: [],
    menuSelected: {},
    loginUser: {},
    customerOrPage: "C",
    loading: false,
    txtSearch: "",
    indexOne: 0,
    nameChangeDialog:false,
    nameChange:{},
  }),
  props: {friendListIndex:Number},
  mounted: function () {
    this.loginUser = this.$store.state.userAccountChat;
    this.selectedOne = this.$store.state.friend;
    //this.$store.commit("updatePage", {});
    this.friendListMethod();
    this.disconnect();
    this.connection();
  },
  methods: {
    clickNameChange:function(){
      this.nameChangeDialog = false;
        friService
        .changeFriendName(this.loginUser.userId,this.nameChange.userAccountId,this.nameChange.profileName)
        .then((response) => {
          this.friendListMethod();
        })
        .catch((error) => {
          
        });
    },
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
      this.connected = false;
    },
    connection() {
      this.connected ? this.disconnect() : this.connect();
    },
    connect() {
      let socket = new SockJS("/chat");
      this.stompClient = Stomp.over(socket);
      this.stompClient.connect(
        {},
        (frame) => {
          this.connected = true;
          this.stompClient.subscribe("/mbt/friends/active", (response) => {
            let userObj = JSON.parse(response.body);
            if (userObj.webSocket == "UA") {
              for (let i = 0; i < this.friendList.length; i++) {
                let obj = this.friendList[i];
                if (userObj.userAccountId == obj.userAccountId) {
                  obj.active = userObj.active;
                }
              }
            } else if (userObj.webSocket == "PM") {
              //Private Message
              //this.friendListMethod();
              if (userObj.userAccountDto != undefined) {
              if(userObj.userAccountDto.userAccountId!=this.loginUser.userId){
                for (let i = 0; i < this.friendList.length; i++) {
                  let obj = this.friendList[i];
                  if (userObj.requestFormId == obj.requestFormId) {
                    obj.sendMessage = userObj.sendMessage;
                    obj.messageDate = userObj.time;
                    obj.look = Number(obj.look) + 1;
                  }
                }
              }
                
              } else {
                for (let i = 0; i < this.friendList.length; i++) {
                  let obj = this.friendList[i];
                  if (userObj.requestFormId == obj.requestFormId) {
                    obj.look = Number(0);
                  }
                }
              }
            }
          });
        },
        (error) => {
          this.connected = false;
        }
      );
    },
    inputSearch: function () {
      this.indexOne = 0;
      window.setTimeout(() => {
        if (this.indexOne == 0) {
          this.indexOne = 1;
          if (this.txtSearch.trim() != "") {
            this.searchMethod();
          } else {
            this.friendList.splice(0);
            this.friendList.push(...this.tempFriendList);
          }
        }
      }, 500); // interval set to one sec.
    },
    searchMethod: function () {
      this.friendList.splice(0);
      this.loading = true;
      for (let i = 0; i < this.tempFriendList.length; i++) {
        let obj = this.tempFriendList[i];
        if (
          obj.profileName
            .toLowerCase()
            .trim()
            .includes(this.txtSearch.toLowerCase().trim())
        ) {
          this.friendList.push(obj);
        }
      }
      this.loading = false;
    },
    clickPageUnLike: function (item) {
      if("Delete"==item.title){
        // pgService
        // .deletePageUser(item)
        // .then((response) => {
        //   this.pageListMethod();
        // })
        // .catch((error) => {
        //   this.$swal("Fail!", error.response.data.message, "error");
        // });
      }else{
        this.nameChangeDialog = true;
        this.nameChange = Object.assign({},item);
      }
      
    },
    menuDialog: function (item) {
      this.rightMenuList.splice(0);
      this.rightMenuList.push({
        title: "Name Change",
      });
      // this.rightMenuList.push({
      //   title: "Delete",
      // });
      this.menu = true;
      this.menuSelected = Object.assign({}, item);
    },
    clickFriend: function (item, index) {
      //item.look = 0;
      this.selectedOne = Object.assign({}, item);
      this.menuSelected = {};
      this.menu = false;
      this.$emit("friendMethod", item, index);
    },
    srcMethod: function (pictureCode) {
      if (pictureCode == undefined) {
        return `/info/logo.png`;
      } else {
        return `${axios.defaults.baseURL}/userphoto/${pictureCode}.png`;
      }
    },
    friendListMethod: function () {
      friService
        .getFriends()
        .then((response) => {
          this.friendList.splice(0, this.friendList.length);
          this.friendList.push(...response);
          this.tempFriendList.splice(0);
          this.tempFriendList.push(...response);
          if (this.selectedOne.userAccountId == undefined) {
            this.selectedOne = this.friendList[0];
          }
        })
        .catch((error) => {
          //this.$swal("Fail!", error.response.data.message, "error");
        });
    },
  },
  watch: {
    friendListIndex(){
      this.friendListMethod();
    }
  },
  components: {},
};
</script>
  <style scoped>
.container {
  position: relative;
  height: 8vh;
  width: 8vh;
}

.bottom-right {
  position: absolute;
  bottom: 0px;
  right: 7px;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.dot {
  height: 10px;
  width: 10px;
  background-color: #00ff62;
  border-radius: 50%;
  display: inline-block;
}
</style>